module.exports = __webpack_public_path__ + "static/media/away.bdff42b0.svg";